import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...action.selectedStatus,
      };
    case actions.SET_NAME:
      return {
        ...state,
        value: {
          ...state.value,
          name: action.name,
        },
      };
    case actions.SET_COLOR:
      return {
        ...state,
        value: {
          ...state.value,
          color: action.color,
        },
      };
    case actions.SET_ORDER:
      return {
        ...state,
        value: {
          ...state.value,
          order: action.order,
        },
      };
    case actions.SET_REMOVED:
      return {
        ...state,
        value: {
          ...state.value,
          isRemoved: action.value,
        },
      };
    case actions.SET_ITEM_COLOR:
      return {
        ...state,
        value: {
          ...state.value,
          items: state.value.items.map((x) => {
            if (x.type === action.itemType) {
              return {
                ...x,
                color: action.color,
              };
            }
            return x;
          }),
        },
      };
    case actions.SET_COMPLETED_ON_SPRINT:
      return {
        ...state,
        value: {
          ...state.value,
          items: state.value.items.map((x) => {
            if (x.type === action.itemType) {
              return {
                ...x,
                isCompleteOnSprint: action.value,
              };
            }
            return x;
          }),
        },
      };
    case actions.SET_CALCULATE_SPENT_TIME:
      return {
        ...state,
        value: {
          ...state.value,
          items: state.value.items.map((x) => {
            if (x.type === action.itemType) {
              return {
                ...x,
                isCalculateSpentTime: action.value,
              };
            }
            return x;
          }),
        },
      };
    case actions.INVALIDATE_CHANGES:
      return {
        ...state,
        changes: action.changes,
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        changes: 0,
        value: action.value,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/status/currentStatus/reducer.js